import axios from 'axios'
import { ServerEnv } from 'Configs/ServerEnv'
import StorePaymentStep from 'GlobalStores/Cores/Elements/StorePaymentStep'
import { ObjectHelpers } from 'Helpers/ObjectHelpers'
import { makeAutoObservable, runInAction } from 'mobx'
import { FeelGreatAPI } from 'Services/FeelGreat/APIs'
import TrackingEvents from 'Services/Tracker/TrackingEvents'
import { createDataLayerItem, trackPurchase } from 'Services/Tracker/DataLayerTrackingEvents'
import Payment from '../Payment'
import StoreAuth from 'GlobalStores/User/StoreAuth'
import storeCredit from 'GlobalStores/StoreCredit'
import storeFeelGreat from 'GlobalStores/FeelGreat/StoreFeelGreat'
import { objectToQueryString } from 'Helpers/GlobalHelpers'
import { PaymentAPIs } from '../PaymentServices/PaymentAPI'

class Singapore {
    autoAddressDisplayKeys = ['street', 'locality', 'postal_code']
    autoAddressKeyToForm = {
        street: 'street_address',
        locality: 'city',
        administrative_area: 'state',
        postal_code: 'zip'
    }

    uuid = ''

    toFormat = {
        enroll: {
            uuid: this.GetUuid(),
            fullName: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            email: '',
            phone: '',
            password: ''
            // password1: '',
            // password2: ''
        },
        enrollWithReferral: {
            uuid: this.GetUuid(),
            fullName: '',
            address: '',
            zip: '',
            email: '',
            phone: '',
            password1: '',
            password2: ''
        },
        shop: {
            uuid: this.GetUuid(),
            fullname: '',
            // address: '', SG we replace it to big_address
            zip: '',
            email: ''
        }
    }

    formShop = {
        fullName: '',
        email: '',
        phone: '',
        street_address: '',
        zip_code: ''
    }

    createAccountWithShippingAddress = {
        type: 'enroll',
        referral_id: '',
        firstname_en: '',
        lastname_en: '',
        email: '',
        phone: '',
        password: '',
        // address: '',
        zip: '',
        period: ''
    }

    ExcludedFieldsShippingIfCreateAccount = ['fullName']

    ExcludedFieldsShipping = []

    mapFormKeyToFormatKey = {
        street_address: 'street',
        fullName: 'fullname',
        zip_code: 'zip',
        firstname: 'firstname_en',
        lastname: 'lastname_en'
    }

    ArrangeCreateCheckoutForm = ['firstname', 'lastname', 'email', 'password', 'phone', 'country', 'unit_number', 'street_address', 'city', 'state', 'zip_code']

    PaymentStep = {
        payment: 0,
        createOrder: 0,
        autoship: -2,
        updateLog: 0
    }

    breadcrumbOption = [
        {
            caption: 'customise',
            link: '/products',
            paramsRequire: false
        },
        {
            caption: 'signup_shipping',
            link: '/checkout/create-account',
            paramsRequire: true,
            authCaption: 'shipping',
            authLink: '/checkout/shipping'
        },
        {
            caption: 'billing',
            link: '/checkout/payment',
            paramsRequire: true
        },
        {
            caption: 'purchase',
            link: '/checkout/review',
            paramsRequire: true
        }
    ]

    shippingMethods = [
        {
            id: 1,
            api_value: 'delivery',
            title: 'standard_delivery',
            dict_key: 'standard_delivery',
            for_status: [],
            options: []
        },
    ]

    orderSummaryConfig = {
        subTotal: {
            display: true,
            dict_key: 'subtotal'
        },
        shipping: {
            display: true,
            dict_key: 'shipping'
        },
        productCredit: {
            display: true,
            dict_key: 'product_credit',
            icon: true,
            allowToUse: []
        },
        vat: {
            display: false,
            dict_key: 'vat',
            value: 0.2 // 20%
        }
    }

    landingLayouts = [
        {
            nameComponent: 'banner',
            titleContent: 'mainBanner',
            style: {}
        },
        {
            nameComponent: 'ourApproach',
            titleContent: 'ourApproach',
            style: {
                minHeight: '0px'
            }
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {
                backgroundColor: '#F1F6FB'
            }
        },
        {
            nameComponent: 'thePractice',
            titleContent: 'thePractice',
            style: {}
        },
        {
            nameComponent: 'howItWorks',
            titleContent: 'howItWorks',
            style: {
                backgroundColor: '#FBF7F1'
            }
        },
        {
            nameComponent: 'whatExpertsSay',
            titleContent: 'expertsSay',
            style: {}
        },
        {
            nameComponent: 'realResults',
            titleContent: 'realResults',
            style: {
                backgroundColor: '#F2F9F8'
            }
        }
    ]

    productLayouts = [
        {
            nameComponent: 'productDetailSelection',
            titleContent: 'productDetailSelection',
            style: {}
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {}
        },
        {
            nameComponent: 'frequentlyAskedQuestions',
            titleContent: 'questions',
            style: {
                backgroundColor: '#F6F9FC'
            }
        }
    ]

    CustomCreateAccountForms = [
        {
            key: 'firstname',
            args: null,
            type: 'text',
            label: 'first_name',
            value: ''
        },
        {
            key: 'lastname',
            args: null,
            type: 'text',
            label: 'last_name',
            value: ''
        },
        {
            key: 'email',
            args: null,
            type: 'text',
            label: 'email_address',
            value: ''
        },
        {
            key: 'password',
            args: null,
            type: 'password',
            label: 'password',
            value: ''
        },
        {
            key: 'phone',
            args: {
                regx: '^[0-9]+$'
            },
            type: 'text',
            label: 'mobile_number',
            value: ''
        },
        {
            key: 'country',
            args: {
                disabled: true
            },
            type: 'CountryBox',
            label: '',
            value: 'Singapore'
        },
        {
            key: 'house_number',
            args: null,
            type: 'text',
            label: 'house_number',
            value: ''
        },
        {
            key: 'street',
            args: null,
            type: 'text',
            label: 'street_name',
            value: ''
        },
        {
            key: 'unit_number',
            args: null,
            type: 'text',
            label: 'unit_number',
            value: ''
        },
        {
            key: 'building_name',
            args: null,
            type: 'text',
            label: 'building_name',
            value: '',
            optional: true
        },
        {
            key: 'zip',
            args: null,
            type: 'text',
            label: 'zip',
            value: ''
        }
    ]

    CustomShippingForms = [
        {
            key: 'firstname',
            args: null,
            type: 'text',
            label: 'first_name',
            value: ''
        },
        {
            key: 'lastname',
            args: null,
            type: 'text',
            label: 'last_name',
            value: ''
        },
        {
            key: 'email',
            args: null,
            type: 'text',
            label: 'email_address',
            value: ''
        },
        {
            key: 'phone',
            args: {
                regx: '^[0-9]+$'
            },
            type: 'text',
            label: 'mobile_number',
            value: ''
        },
        {
            key: 'country',
            args: {
                disabled: true
            },
            type: 'CountryBox',
            label: '',
            value: 'Singapore'
        },
        {
            key: 'house_number',
            args: null,
            type: 'text',
            label: 'house_number',
            value: ''
        },
        {
            key: 'street',
            args: null,
            type: 'text',
            label: 'street_name',
            value: ''
        },
        {
            key: 'unit_number',
            args: null,
            type: 'text',
            label: 'unit_number',
            value: ''
        },
        {
            key: 'building_name',
            args: null,
            type: 'text',
            label: 'building_name',
            value: '',
            optional: true
        },
        {
            key: 'zip',
            args: null,
            type: 'text',
            label: 'zip',
            value: ''
        }
    ]

    paymentMethod = 'creditcard'


    oldNewSKUMapping = {
        "34996": "36916", // Lemon
        "34997": "36917" // Lemon Ginger
    }


    GetPaymentMethod() {
        return this.paymentMethod
    }

    MapAutoAddressToForm(form, autoAddressData) {
        const swappedValuesAsKeys = ObjectHelpers.swapKeysAndValues(this.autoAddressKeyToForm)
        return form.map(item => {
            if (swappedValuesAsKeys[item.key]) {
                if (autoAddressData.data) {
                    item.value = autoAddressData.data[swappedValuesAsKeys[item.key]]
                }
            }

            return item
        })
    }

    FormToFormat(type, form) {
        form.map(item => {
            if (this.mapFormKeyToFormatKey[item.key]) {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][this.mapFormKeyToFormatKey[item.key]] = item.value
                    })
                }
            } else {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][item.key] = item.value
                    })
                }
            }

            return item
        })
    }

    SetUuid(value) {
        this.uuid = value
    }

    GetUuid() {
        return this.uuid
    }

    GetFormat(type) {
        return this.toFormat[type]
    }

    GetPaymentStep() {
        return this.PaymentStep
    }

    GetBreadcrumbOption() {
        return this.breadcrumbOption
    }

    GetShippingMethod() {
        return this.shippingMethods
    }

    SetPaymentStep(key, value) {
        this.PaymentStep[key] = value
    }
    GetOrderSummaryConfig() {
        return this.orderSummaryConfig
    }

    GetLandingLayout() {
        return this.landingLayouts
    }

    GetProductLayout() {
        return this.productLayouts
    }

    /**
     *
     * @param {*} uuid
     * @param {object} detailPage { products, detailPage, isSubscribe, isEnroll, type}
     * @param {*} CreditCardEncrypted
     */
    async SubmitPayment(uuid, detailPage, CreditCardEncrypted, billingAddressForm, products, options, type, CreditCardAlias) {
        if (CreditCardAlias && CreditCardAlias.length > 0) {
            return this.SubmitPaymentAliasFlow(uuid, detailPage, CreditCardEncrypted, products, CreditCardAlias)
        } else {
            const Pay = new Payment(uuid, detailPage)
            try {
                const responsePreparePayment = await Pay.PreparePaymentData()
                const allowCreditEnable = StoreAuth.IsAllowCredit()

                if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                    Pay.hydra.transactions = {
                        items: [CreditCardEncrypted, storeCredit.ProductCreditUsed()]
                    }
                } else {
                    Pay.hydra.transactions = {
                        items: [CreditCardEncrypted]
                    }
                }

                const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)

                await Pay.PostToHydraWithCreateAutoShip()

                Pay.SendEmailV4()
                Pay.SendSms()

                await Pay.UpdateToLog(Pay.hydra.transactions, hasSubscribe ? 1 : 0, false, 'success')

                const responsePaymentDetail = await PaymentAPIs.GetPaymentDetail(responsePreparePayment.data.data.payment_id)
                runInAction(() => {
                    StorePaymentStep.PaymentDone = true
                })

                try {
                    TrackingEvents.PurchaseEvent({
                        transaction_id: responsePreparePayment.data.data.payment_id,
                        value: Pay.ushop.total_price,
                        currency: 'SGD',
                        category: Pay.ushop.shipment_purchas_option,
                        items: products
                    })
                    trackPurchase({
                        transaction_id: responsePreparePayment.data.data.payment_id,
                        currency: 'SGD',
                        value: Pay.ushop.total_price,
                        items: Array.isArray(products) ? products.map(item => createDataLayerItem(item)) : []
                    })
                } catch (e) {
                    console.error('TrackingEvents.PurchaseEvent', e)
                }
                return {
                    success: true,
                    payment_id: responsePreparePayment.data.data.payment_id,
                    order_number: responsePaymentDetail.data.order_number
                }
            } catch (error) {
                console.error(error)
                const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)
                Pay.UpdateToLog(Pay.hydra?.transactions, hasSubscribe ? 1 : 0, true, 'error')
                runInAction(() => {
                    StorePaymentStep.PaymentDone = true
                })

                return { success: false }
            }
        }
    }

    async SubmitPaymentAliasFlow(uuid, detailPage, CreditCardEncrypted, products, CreditCardAlias) {
        const Pay = new Payment(uuid, detailPage)
        console.log('SubmitPaymentAliasFlow')

        try {
            const responsePreparePayment = await Pay.PreparePaymentData()
            const allowCreditEnable = StoreAuth.IsAllowCredit()
            if (CreditCardAlias && CreditCardAlias.length > 0) {
                const creditCardAliasData = {
                    type: 'AuthorizeAndCapture',
                    method: 'CreditCardAlias',
                    methodDetails: {
                        alias: CreditCardAlias
                    },
                    amount: 'this.terms.total'
                }

                if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                    let amount = Number(Pay.ushop.total_price) - Number(storeCredit.ProductCreditUsed().amount)
                    if (amount > 0) {
                        creditCardAliasData.amount = Number(amount)
                        Pay.hydra.transactions = {
                            items: [creditCardAliasData, storeCredit.ProductCreditUsed()]
                        }
                    } else {
                        Pay.hydra.transactions = {
                            items: [storeCredit.ProductCreditUsed()]
                        }
                    }
                } else {
                    Pay.hydra.transactions = {
                        items: [creditCardAliasData]
                    }
                }
            } else {
                if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                    Pay.hydra.transactions = {
                        items: [CreditCardEncrypted, storeCredit.ProductCreditUsed()]
                    }
                } else {
                    Pay.hydra.transactions = {
                        items: [CreditCardEncrypted]
                    }
                }
            }

            await Pay.PostToHydraWithCreateAutoShip()

            Pay.SendEmailV4()
            Pay.SendSms()

            const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)
            if (hasSubscribe) {
                await Pay.UpdateToLog(Pay.hydra.transactions, 1, false, 'success')
            } else {
                await Pay.UpdateToLog(Pay.hydra.transactions, 0, false, 'success')
            }

            const responsePaymentDetail = await PaymentAPIs.GetPaymentDetail(responsePreparePayment.data.data.payment_id)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })
            try {
                TrackingEvents.PurchaseEvent({
                    transaction_id: responsePreparePayment.data.data.payment_id,
                    value: Pay.ushop.total_price,
                    currency: 'SGD',
                    category: Pay.ushop.shipment_purchas_option,
                    items: products
                })
                trackPurchase({
                    transaction_id: responsePreparePayment.data.data.payment_id,
                    currency: 'SGD',
                    value: Pay.ushop.total_price,
                    items: Array.isArray(products) ? products.map(item => createDataLayerItem(item)) : []
                })
            } catch (e) {
                console.error('TrackingEvents.PurchaseEvent', e)
            }
            return {
                success: true,
                payment_id: responsePreparePayment.data.data.payment_id,
                order_number: responsePaymentDetail.data.order_number
            }
        } catch (error) {
            console.error(error)
            const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)
            Pay.UpdateToLog(Pay.hydra?.transactions, hasSubscribe ? 1 : 0, true, 'error')
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })

            return { success: false }
        }
    }

    async CreateAccount(uuid, accForm, shippingForm, referral, cartItems) {
        try {
            const forms = Object.assign(this.createAccountWithShippingAddress, accForm)
            const returnShippingAddress = {}
            shippingForm.map(item => {
                if (this.ExcludedFieldsShippingIfCreateAccount.includes(item.key)) {
                    return false
                }
                if (this.mapFormKeyToFormatKey[item.key]) {
                    forms[this.mapFormKeyToFormatKey[item.key]] = item.value
                    returnShippingAddress[this.mapFormKeyToFormatKey[item.key]] = item.value
                } else {
                    forms[item.key] = item.value
                    returnShippingAddress[item.key] = item.value
                }
            })

            if (referral) {
                forms.referral_id = referral
            } else {
                delete forms.referral_id
            }

            delete forms.country

            const queryStrings = objectToQueryString({
                dev: ServerEnv.ENV === 'DEV' ? '1' : undefined,
                emailDelay: ServerEnv.ENV === 'DEV' ? undefined : '1h',
                isSkipCheckPassword: storeFeelGreat.passwordSettings.isUseComplexPassword ? '1' : undefined
            })

            const periodResponse = await FeelGreatAPI.GetPeriod('SG')
            forms.period = periodResponse.data.entryPeriod
            forms.uuid = uuid
            forms.shipment_packs = JSON.stringify(cartItems)
            const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/formatV2/SGP/feelGreat/createAccount${queryStrings}`
            const response = await axios.post(url, forms)

            return {
                ...response.data,
                form: forms
            }
        } catch (e) {
            console.error(e)

            return {
                success: false
            }
        }
    }

    pageConfig = {
        signUp: {
            disable: true
        }
    }

    GetPageConfig() {
        return this.pageConfig
    }

    constructor() {
        StorePaymentStep.SetPaymentSteps(this.PaymentStep)
        makeAutoObservable(this)
    }
}

export default Singapore
